'use client'

import { ArrowRight } from 'lucide-react'
import Input from '@/components/elements/Input'
import { Button } from '@/components/elements/Button'
import { useRegisterForm } from '@/lib/commerce/hooks'
import { formatImageURL } from '@/utils/util'

export default function Register({ vendor }: { vendor?: any }) {
  const f = useRegisterForm(vendor)

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        {vendor?.logo ? (
          <img src={formatImageURL(vendor.logo)} alt={vendor?.name || ''} className="h-8 max-w-32 w-auto object-contain" />
        ) : vendor?.name ? (
          <div className="text-[18px] font-bold tracking-tight text-foreground">{vendor.name}</div>
        ) : null}
      </div>

      <h1 className="text-[36px] sm:text-[40px] font-bold font-gilroy tracking-[-0.025em] leading-[1.05] text-foreground">
        Бүртгэл үүсгэх
      </h1>
      <p className="mt-2 text-[14px] text-foreground/55">
        Хэдхэн алхамд бэлэн болно.
      </p>

      <form onSubmit={f.handleRegister} className="mt-7 flex flex-col gap-4">
        <div className="grid grid-cols-2 gap-3">
          <Input label="Овог" placeholder="Таны овог" onChange={(e: any) => f.setLastName(e.target.value)} autoFocus />
          <Input label="Нэр" placeholder="Таны нэр" onChange={(e: any) => f.setFirstName(e.target.value)} />
        </div>
        <Input label="Имэйл хаяг" type="email" placeholder="example@shop.mn" onChange={(e: any) => f.setEmail(e.target.value)} />
        <Input label="Утасны дугаар" type="text" placeholder="00000000" onChange={(e: any) => f.setPhone(e.target.value)} />
        <Input label="Шинэ нууц үг" type="password" placeholder="Таны шинэ нууц үг" onChange={(e: any) => f.setPassword(e.target.value)} onKeyDown={f.handleKeyDown} description="8-аас дээш тэмдэгтэй байх ёстой" />
        <Button type="submit" isLoading={f.loading} icon={ArrowRight} iconPosition="right" variant="outline" className="mt-2 w-full h-14 rounded-full! bg-foreground text-cream font-semibold! border-foreground hover:bg-foreground/90 hover:text-cream transition-all" loadingMessage="Бүртгүүлж байна...">
          Бүртгүүлэх
        </Button>
      </form>

      <p className="mt-7 text-[14px] text-center text-foreground/65">
        Аль хэдийн бүртгэлтэй юу?{' '}
        <span onClick={f.routeToLogin} className="cursor-pointer font-semibold text-foreground underline underline-offset-[3px] hover:text-foreground/80 transition-colors">
          Нэвтрэх
        </span>
      </p>
    </div>
  )
}
